import Newsletter from "../components/shared/newsletter";
import SendTerm from "../components/hotels/show_tour/send_term";
import HotelOtherList from "../components/hotels/show_tour/hotel_other_list";
import Configuration from "../components/configuration/configuration";
import WeatherGraph from "../components/hotels/show_tour/weather_graph";
import SyncTerm from "../components/hotels/show_tour/sync_term";
import RatingsSection from "../components/hotels/show_tour/ratings_section";
import HotelCalculationList from "../components/hotels/show_tour/hotel_calculation_list";
import mountReactComponents from "../src/render_components";

mountReactComponents({
  Newsletter,
  SendTerm,
  HotelOtherList,
  Configuration,
  WeatherGraph,
  SyncTerm,
  RatingsSection,
  HotelCalculationList
});
